export const columnsTable = [
  { title: 'ID', dataIndex: 'contractId', key: 'contractId' },
  { title: 'Estado', dataIndex: 'state', key: 'state' },
  { title: 'Área', dataIndex: 'userArea', key: 'userArea' },
  {
    title: 'Fecha de Creación',
    dataIndex: 'contractDate',
    key: 'contractDate',
  },
];

export const states = {
  New: 'Nuevo',
  Process: 'Proceso',
  Review: 'Revision',
  Observed: 'Observado',
  Validation: 'validation',
  Finalized: 'Finalizado',
  Cancelled: 'Cancelado',
};
